import React, { useState, useEffect } from 'react';
import { 
  makeStyles,
  Grid, 
  Card,
  CardContent,
  Typography, 
  Button, 
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  Box,
  Divider,
  CircularProgress,
  Snackbar,
  IconButton,
  Paper,
  Tabs,
  Tab,
  Switch,
  FormGroup
} from '@material-ui/core';
import { ChromePicker } from 'react-color';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import SalesPage from 'views/SalesPage/SalesPage';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-hot-toast';
import DeleteIcon from '@material-ui/icons/Delete';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    gap: '20px',
    padding: '20px',
    height: 'calc(100vh - 200px)',
    overflow: 'hidden',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '10px'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: '200px',
    '& .MuiTab-root': {
      color: 'white',
      alignItems: 'flex-start',
      textAlign: 'left',
      width: '100%',
      '&.Mui-selected': {
        color: '#f00'
      }
    }
  },
  tabPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: '20px',
    height: '100%'
  },
  previewContainer: {
    width: '50%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '10px',
    padding: '10px',
    overflowY: 'auto'
  },
  previewWrapper: {
    transform: 'scale(0.5)',
    transformOrigin: 'top left',
    width: '200%',
    height: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    overflow: 'hidden'
  },
  mainContent: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '100%',
    overflow: 'hidden'
  },
  colorPicker: {
    marginTop: '10px',
    padding: '10px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px'
  },
  textField: {
    marginBottom: '20px',
    '& .MuiInputBase-input': {
      color: 'white'
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.23)'
      }
    },
    '& .MuiFormHelperText-root': {
      color: 'rgba(255, 255, 255, 0.7)'
    }
  },
  section: {
    marginBottom: theme.spacing(4)
  },
  sectionTitle: {
    color: '#fff',
    marginBottom: theme.spacing(2)
  },
  saveButton: {
    position: 'sticky',
    bottom: theme.spacing(2),
    width: 'auto',
    margin: theme.spacing(2),
    alignSelf: 'flex-end'
  },
  card: {
    backgroundColor: 'rgba(217, 217, 217, 0.3)',
    color: 'white',
    height: '100%'
  },
  formControl: {
    marginBottom: '16px',
    '& .MuiFormLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiRadio-root': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .Mui-checked': {
      color: 'white'
    },
    '& .MuiFormControlLabel-label': {
      color: 'white'
    }
  },
  colorButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    border: '1px solid rgba(255, 255, 255, 0.23)',
    padding: '10px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.5)'
    }
  },
  colorPreview: {
    width: '24px',
    height: '24px',
    marginRight: '10px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    borderRadius: '4px'
  },
  colorPickerPopover: {
    position: 'absolute',
    zIndex: 1000,
    marginTop: '10px'
  },
  divider: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    margin: '20px 0'
  },
  colorControl: {
    marginBottom: '20px',
    padding: '15px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)'
  },
  tabsContainer: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden'
  },
  uploadButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  uploadPreview: {
    marginTop: theme.spacing(2),
    width: '100%',
    maxWidth: '300px',
    borderRadius: theme.spacing(1),
    overflow: 'hidden'
  },
  uploadProgress: {
    marginLeft: theme.spacing(2)
  },
  tabContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: '20px',
    height: '100%'
  },
  colorPickers: {
    display: 'flex',
    gap: '20px'
  },
  colorPickerContainer: {
    position: 'relative',
    marginBottom: '20px'
  },
  popover: {
    position: 'absolute',
    zIndex: 2,
    top: '45px'
  },
  cover: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  testimonialsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '20px'
  },
  testimonialCard: {
    background: 'rgba(255, 255, 255, 0.9)'
  },
  imageUpload: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '10px'
  },
  imagePreview: {
    width: '50px',
    height: '50px',
    objectFit: 'cover',
    borderRadius: '25px'
  },
  addButton: {
    marginTop: '20px'
  },
  sectionOrderingContainer: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  draggableSection: {
    padding: '10px',
    margin: '5px 0',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '4px',
    cursor: 'move',
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.3)',
    },
  },
  dragHandle: {
    marginRight: '10px',
    cursor: 'grab',
  },
  subsectionTitle: {
    color: 'white',
    marginBottom: '10px',
    fontWeight: 500
  },
  badgesSection: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    marginTop: '20px',
    padding: '20px',
    backgroundColor: 'transparent',
    borderRadius: '12px',
  },
  badge: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '15px',
    '& img': {
      width: '64px',
      height: '64px',
      marginBottom: '10px',
    },
    '& h4': {
      margin: '0 0 5px 0',
      fontSize: '16px',
      fontWeight: 600,
      color: '#ffffff',
    },
    '& p': {
      margin: 0,
      fontSize: '14px',
      color: '#ffffff',
      lineHeight: 1.4,
    },
  },
  resetButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: 'rgba(255, 0, 0, 0.2)',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: 'rgba(255, 0, 0, 0.3)',
    },
  },
  salesPageToggle: {
    marginTop: '20px',
    padding: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    '& .MuiFormControlLabel-label': {
      color: 'white'
    }
  },
  thumbnailPreview: {
    width: '120px',
    height: '68px', // 16:9 aspect ratio
    objectFit: 'cover',
    borderRadius: '4px',
    marginLeft: '10px'
  },
  videoPreview: {
    marginTop: '20px',
    marginBottom: '20px',
    width: '100%',
    borderRadius: '4px',
    overflow: 'hidden'
  },
  videoUploadSection: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  uploadButtons: {
    display: 'flex',
    gap: '10px',
    marginTop: '10px',
    marginBottom: '20px',
  },
  previewSection: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%', // 16:9 aspect ratio
    height: 0,
    '& iframe, & video': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '4px',
    }
  },
  viewButtons: {
    display: 'flex',
    gap: '10px',
    marginLeft: '20px'
  },
  viewButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    }
  },
}));

export const defaultContent = {
  title: "Meet Girls Everywhere",
  subtitle: "20+ Modules to Transform Your Dating Life",
  logo: {
    enabled: false,
    url: '',
    position: 'above', // 'above', 'between', or 'below'
    maxWidth: '200px',
    marginTop: '20px',
    marginBottom: '20px'
  },
  mediaType: 'video',
  mediaUrl: "https://www.youtube.com/watch?v=YOUR_DEFAULT_VIDEO_ID",
  features: [
    {
      title: "Learn Proven Techniques",
      description: "Master the art of approaching and connecting with women in any location"
    },
    {
      title: "Build Genuine Confidence",
      description: "Develop natural confidence that attracts women authentically"
    },
    {
      title: "Real-World Practice",
      description: "Get practical exercises and real-world examples to improve your skills"
    },
    {
      title: "Expert Guidance",
      description: "Learn from experienced instructors who have proven success"
    }
  ],
  testimonials: [
    {
      videoUrl: "https://www.youtube.com/watch?v=example1",
      thumbnail: "https://example.com/thumbnail1.jpg",
      header: "",
      subtext: ""
    },
    {
      videoUrl: "https://www.youtube.com/watch?v=example2",
      thumbnail: "https://example.com/thumbnail2.jpg",
      header: "",
      subtext: ""
    },
    {
      videoUrl: "https://www.youtube.com/watch?v=example3",
      thumbnail: "https://example.com/thumbnail3.jpg",
      header: "",
      subtext: ""
    }
  ],
  testimonialSection: {
    heading: "See What Our Students Are Saying",
    subtext: ""
  },
  instructor: {
    bio: "Hi, I'm Hector Castillo, and I've been teaching men how to successfully meet and connect with women for over a decade. Through years of experience and real-world testing, I've developed proven methods that work in any location - whether it's at the beach, in a mall, or on public transportation. My approach focuses on authentic connections and genuine confidence.",
    achievements: [
      "Over 10 years of coaching experience",
      "Helped thousands of students improve their dating lives",
      "Author of multiple successful dating guides",
      "Featured in major dating and lifestyle publications"
    ]
  },
  courseDescription: {
    mainHeading: "🚀 Transform Your Dating Life",
    overview: "Meet Girls Everywhere – The Ultimate Course to Master Social Dynamics and Attraction: If you're tired of swiping endlessly, feeling stuck in your dating life, or simply not getting the results you want with women, Meet Girls Everywhere is the solution you've been waiting for. This isn't just another course on pickup lines or awkward routines. This is a complete system for understanding women, building your confidence, and mastering the art of attraction in everyday life.",
    whatIs: {
      heading: "💡 What is \"Meet Girls Everywhere\"?",
      content: "\"Meet Girls Everywhere\" is a deep-dive, no-fluff program created by dating and social dynamics expert Hector Castillo. This step-by-step course guides you through the mindset, behaviors, habits, and skills needed to naturally and confidently meet women—in any situation. Whether you're walking down the street, in a coffee shop, at the gym, or just out with friends, this course teaches you how to turn daily life into opportunity."
    },
    readyToStart: {
      heading: "Ready to Get Started",
      content: "This step-by-step course guides you through the mindset, behaviors, habits, and skills needed to naturally and confidently meet women—in any situation. Whether you're walking down the street, in a coffee shop, at the gym, or just out with friends, this course teaches you how to turn daily life into opportunity."
    }
  },
  sectionOrder: {
    left: ['title', 'video', 'features', 'testimonials', 'instructor', 'description', 'bonuses'],
    right: ['payment', 'bonuses']
  },
  visibleSections: {
    left: {
      title: true,
      video: true,
      features: true,
      testimonials: true,
      instructor: true,
      description: true,
      bonuses: true
    },
    right: {
      payment: true,
      bonuses: true
    }
  }
};

export const defaultStyles = {
  backgroundType: 'gradient',
  gradientStart: '#ff0000',
  gradientEnd: '#990000',
  backgroundColor: '#ffffff',
  backgroundImage: '',
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  overlayOpacity: 0.5,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  textColor: '#ffffff',
  textColors: {
    title: '#ffffff',
    subtitle: '#ffffff'
  },
  containerBackgroundColor: 'rgba(0, 0, 0, 0.3)'
};

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const DraggableSectionList = ({ sections, onReorder, side }) => {
  const classes = useStyles();
  const [items, setItems] = useState(sections || defaultContent.sectionOrder[side]);

  useEffect(() => {
    if (sections && Array.isArray(sections)) {
      setItems(sections);
    } else {
      setItems(defaultContent.sectionOrder[side]);
    }
  }, [sections, side]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);

    setItems(newItems);
    onReorder(newItems, side);
  };

  return (
    <div className={classes.sectionOrderingContainer}>
      <Typography variant="subtitle1" style={{ color: 'white', marginBottom: '10px' }}>
        {side === 'left' ? 'Left Panel Order' : 'Right Panel Order'}
      </Typography>
      <Paper style={{ background: 'rgba(255, 255, 255, 0.1)', padding: '10px' }}>
        {items.map((section, index) => (
          <div
            key={section}
            className={classes.draggableSection}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData('text/plain', index.toString());
              e.currentTarget.style.opacity = '0.5';
            }}
            onDragEnd={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
            onDragOver={(e) => {
              e.preventDefault();
              e.currentTarget.style.borderTop = '2px solid #fff';
            }}
            onDragLeave={(e) => {
              e.currentTarget.style.borderTop = 'none';
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.currentTarget.style.borderTop = 'none';
              const sourceIndex = parseInt(e.dataTransfer.getData('text/plain'));
              const targetIndex = index;
              
              if (sourceIndex === targetIndex) return;
              
              const newItems = Array.from(items);
              const [removed] = newItems.splice(sourceIndex, 1);
              newItems.splice(targetIndex, 0, removed);
              
              setItems(newItems);
              onReorder(newItems, side);
            }}
          >
            <span className={classes.dragHandle}>☰</span>
            {section.charAt(0).toUpperCase() + section.slice(1)}
          </div>
        ))}
      </Paper>
    </div>
  );
};

const SectionVisibilityControls = ({ content, onContentChange }) => {
  const classes = useStyles();
  const allSections = [
    { id: 'title', label: 'Title Section' },
    { id: 'video', label: 'Video/Media Section' },
    { id: 'features', label: 'Features Section' },
    { id: 'testimonials', label: 'Testimonials Section' },
    { id: 'instructor', label: 'Instructor Section' },
    { id: 'description', label: 'Course Description' },
    { id: 'payment', label: 'Payment Section' },
    { id: 'bonuses', label: 'Bonuses Section' }
  ];

  const handleVisibilityChange = (sectionId, side, isVisible) => {
    const newVisibility = {
      ...content.visibleSections,
      [side]: {
        ...(content.visibleSections?.[side] || {}),
        [sectionId]: isVisible
      }
    };
    onContentChange('visibleSections', newVisibility);
  };

  return (
    <div className={classes.section}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Section Visibility
      </Typography>
      
      <Typography variant="subtitle1" className={classes.subsectionTitle} style={{ marginTop: '20px' }}>
        Left Panel
      </Typography>
      {allSections.filter(section => content.sectionOrder.left.includes(section.id)).map(section => (
        <FormControlLabel
          key={`left-${section.id}`}
          control={
            <Switch
              checked={content.visibleSections?.left?.[section.id] ?? true}
              onChange={(e) => handleVisibilityChange(section.id, 'left', e.target.checked)}
              name={`left-${section.id}`}
            />
          }
          label={section.label}
          style={{ color: 'white' }}
        />
      ))}

      <Typography variant="subtitle1" className={classes.subsectionTitle} style={{ marginTop: '20px' }}>
        Right Panel
      </Typography>
      {allSections.filter(section => content.sectionOrder.right.includes(section.id)).map(section => (
        <FormControlLabel
          key={`right-${section.id}`}
          control={
            <Switch
              checked={content.visibleSections?.right?.[section.id] ?? true}
              onChange={(e) => handleVisibilityChange(section.id, 'right', e.target.checked)}
              name={`right-${section.id}`}
            />
          }
          label={section.label}
          style={{ color: 'white' }}
        />
      ))}
    </div>
  );
};

const BadgeManager = ({ badges, onChange }) => {
  const classes = useStyles();

  const handleBadgeChange = (index, field, value) => {
    const newBadges = [...badges];
    newBadges[index] = {
      ...newBadges[index],
      [field]: value
    };
    onChange(newBadges);
  };

  const handleImageUpload = async (event, index) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const storage = getStorage();
      const storageRef = ref(storage, `badge-images/${Date.now()}_${file.name}`);
      
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      
      handleBadgeChange(index, 'image', downloadURL);
    } catch (error) {
      console.error('Error uploading badge image:', error);
      toast.error('Failed to upload badge image');
    }
  };

  return (
    <div className={classes.section}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Trust Badges
      </Typography>
      <Typography variant="subtitle2" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '20px' }}>
        Add up to 3 badges to display under the payment form
      </Typography>
      
      {badges.map((badge, index) => (
        <Box key={index} mb={2} p={2} border="1px solid rgba(255, 255, 255, 0.23)" borderRadius="4px">
          <div className={classes.imageUpload}>
            <input
              accept="image/*"
              type="file"
              id={`badge-image-${index}`}
              style={{ display: 'none' }}
              onChange={(e) => handleImageUpload(e, index)}
            />
            <label htmlFor={`badge-image-${index}`}>
              <Button
                variant="contained"
                component="span"
                className={classes.uploadButton}
              >
                Upload Badge Icon
              </Button>
            </label>
            {badge.image && (
              <img
                src={badge.image}
                alt="Badge Preview"
                className={classes.imagePreview}
              />
            )}
          </div>
          
          <TextField
            className={classes.textField}
            fullWidth
            label="Badge Title"
            value={badge.title}
            onChange={(e) => handleBadgeChange(index, 'title', e.target.value)}
            variant="outlined"
            margin="dense"
          />
          
          <TextField
            className={classes.textField}
            fullWidth
            label="Badge Description"
            value={badge.description}
            onChange={(e) => handleBadgeChange(index, 'description', e.target.value)}
            variant="outlined"
            margin="dense"
            multiline
            rows={2}
          />
        </Box>
      ))}
    </div>
  );
};

// Add this helper function before the component definition
const getYouTubeEmbedUrl = (url) => {
  if (!url) return '';
  
  try {
    let baseUrl = '';
    
    // Handle youtu.be format
    if (url.includes('youtu.be')) {
      const videoId = url.split('youtu.be/')[1]?.split('?')[0];
      if (videoId) {
        baseUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    }
    // Handle youtube.com format
    else if (url.includes('youtube.com/watch')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      if (videoId) {
        baseUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    }
    // If it's already an embed URL
    else if (url.includes('youtube.com/embed/')) {
      baseUrl = url;
    } else {
      return url;
    }

    // Add parameters
    const params = new URLSearchParams({
      autoplay: '0',
      controls: '1',
      showinfo: '0',
      rel: '0',
      modestbranding: '1',
      playsinline: '1'
    });

    return `${baseUrl}?${params.toString()}`;
  } catch (error) {
    console.error('Error parsing YouTube URL:', error);
    return url;
  }
};

export default function SalesPageCustomizer() {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);
  const [styles, setStyles] = useState(defaultStyles);
  const [content, setContent] = useState(defaultContent);
  const [stagingStyles, setStagingStyles] = useState(defaultStyles);
  const [stagingContent, setStagingContent] = useState(defaultContent);
  const [currentVersion, setCurrentVersion] = useState('live'); // 'live' or 'staging'
  const [showGradientStartPicker, setShowGradientStartPicker] = useState(false);
  const [showGradientEndPicker, setShowGradientEndPicker] = useState(false);
  const [showSolidColorPicker, setShowSolidColorPicker] = useState(false);
  const [showOverlayColorPicker, setShowOverlayColorPicker] = useState(false);
  const [showTitleColorPicker, setShowTitleColorPicker] = useState(false);
  const [showSubtitleColorPicker, setShowSubtitleColorPicker] = useState(false);
  const [showFeaturesColorPicker, setShowFeaturesColorPicker] = useState(false);
  const [showTextColorPicker, setShowTextColorPicker] = useState(false);
  const [showContainerColorPicker, setShowContainerColorPicker] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [editingTestimonialIndex, setEditingTestimonialIndex] = useState(null);

  useEffect(() => {
    loadStylesAndContent();
  }, []);

  const loadStylesAndContent = async () => {
    try {
      const db = getFirestore();
      const [liveStylesDoc, liveContentDoc, stagingStylesDoc, stagingContentDoc] = await Promise.all([
        getDoc(doc(db, 'siteConfig', 'salesPageStyles')),
        getDoc(doc(db, 'siteConfig', 'salesPageContent')),
        getDoc(doc(db, 'siteConfig', 'salesPageStylesStaging')),
        getDoc(doc(db, 'siteConfig', 'salesPageContentStaging'))
      ]);

      // Load live version
      if (liveStylesDoc.exists()) {
        setStyles(liveStylesDoc.data());
      }
      if (liveContentDoc.exists()) {
        setContent(prev => ({
          ...defaultContent,
          ...liveContentDoc.data()
        }));
      }

      // Load staging version
      if (stagingStylesDoc.exists()) {
        setStagingStyles(stagingStylesDoc.data());
      } else {
        // If no staging version exists, copy from live
        setStagingStyles(liveStylesDoc.exists() ? liveStylesDoc.data() : defaultStyles);
      }
      if (stagingContentDoc.exists()) {
        setStagingContent(prev => ({
          ...defaultContent,
          ...stagingContentDoc.data()
        }));
      } else {
        // If no staging version exists, copy from live
        setStagingContent(liveContentDoc.exists() ? liveContentDoc.data() : defaultContent);
      }
    } catch (error) {
      console.error('Error loading styles and content:', error);
      toast.error('Error loading saved settings');
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Helper to get current version's content and styles
  const currentStyles = currentVersion === 'live' ? styles : stagingStyles;
  const currentContent = currentVersion === 'live' ? content : stagingContent;
  const setCurrentContent = currentVersion === 'live' ? setContent : setStagingContent;
  const setCurrentStyles = currentVersion === 'live' ? setStyles : setStagingStyles;

  const handleContentChange = (section, subsection, value) => {
    setCurrentContent(prev => {
      const newContent = { ...prev };
      
      if (typeof section === 'string' && !subsection) {
        newContent[section] = value;
      } else if (typeof subsection === 'object') {
        newContent[section] = subsection;
      } else if (subsection === null) {
        newContent[section] = Array.isArray(value) ? value : [];
      } else {
        newContent[section] = {
          ...(prev[section] || {}),
            [subsection]: value
        };
      }
      
      return newContent;
    });
  };

  const handleSave = async () => {
    try {
      const db = getFirestore();
      const version = currentVersion === 'live' ? '' : 'Staging';
      
      console.log(`Saving ${currentVersion} version...`);
      console.log('Current styles:', currentStyles);
      console.log('Current content:', currentContent);

      // Prepare the styles object with all necessary properties
      const stylesToSave = {
        ...defaultStyles,
        ...currentStyles,
        backgroundType: currentStyles.backgroundType || defaultStyles.backgroundType,
        gradientStart: currentStyles.gradientStart || defaultStyles.gradientStart,
        gradientEnd: currentStyles.gradientEnd || defaultStyles.gradientEnd,
        backgroundColor: currentStyles.backgroundColor || defaultStyles.backgroundColor,
        backgroundImage: currentStyles.backgroundImage || defaultStyles.backgroundImage,
        overlayColor: currentStyles.overlayColor || defaultStyles.overlayColor,
        overlayOpacity: currentStyles.overlayOpacity || defaultStyles.overlayOpacity,
        textColor: currentStyles.textColor || defaultStyles.textColor,
        containerBackgroundColor: currentStyles.containerBackgroundColor || defaultStyles.containerBackgroundColor,
        textColors: {
          ...defaultStyles.textColors,
          ...(currentStyles.textColors || {}),
          title: currentStyles.textColors?.title || defaultStyles.textColors.title,
          subtitle: currentStyles.textColors?.subtitle || defaultStyles.textColors.subtitle
        }
      };

      // Prepare the content object with all necessary properties
      const contentToSave = {
        ...defaultContent,
        ...currentContent,
        sectionOrder: {
          ...defaultContent.sectionOrder,
          ...(currentContent.sectionOrder || {})
        },
        visibleSections: {
          ...defaultContent.visibleSections,
          ...(currentContent.visibleSections || {})
        }
      };

      console.log('Saving styles:', stylesToSave);
      console.log('Saving content:', contentToSave);

      // Save both content and styles
      await Promise.all([
        setDoc(doc(db, 'siteConfig', `salesPageStyles${version}`), stylesToSave),
        setDoc(doc(db, 'siteConfig', `salesPageContent${version}`), contentToSave)
      ]);

      toast.success(`Changes saved to ${currentVersion} version!`);
    } catch (error) {
      console.error('Error saving changes:', error);
      toast.error('Error saving changes. Please try again.');
    }
  };

  const handlePromoteToLive = async () => {
    const confirmPromote = window.confirm(
      'Are you sure you want to promote the staging version to live? This will overwrite the current live version.'
    );

    if (confirmPromote) {
      try {
        const db = getFirestore();
        
        // Copy staging to live
        await Promise.all([
          setDoc(doc(db, 'siteConfig', 'salesPageStyles'), stagingStyles),
          setDoc(doc(db, 'siteConfig', 'salesPageContent'), stagingContent)
        ]);

        // Update local state
        setStyles(stagingStyles);
        setContent(stagingContent);
        
        toast.success('Staging version has been promoted to live!');
      } catch (error) {
        console.error('Error promoting to live:', error);
        toast.error('Error promoting to live. Please try again.');
      }
    }
  };

  const handleResetTab = () => {
    const tabToSection = {
      0: ['title', 'subtitle', 'mediaType', 'mediaUrl'], // General
      1: ['features'], // Features
      2: ['testimonials', 'testimonialSection'], // Testimonials
      3: ['instructor'], // Instructor
      4: ['courseDescription'], // Course Description
      5: ['bonuses'], // Bonuses
      6: [], // Colors & Theme (handled separately)
      7: ['sectionOrder', 'visibleSections'], // Layout
      8: ['badges'] // Badges & Payment
    };

    const confirmMessage = (() => {
      switch (currentTab) {
        case 0:
          return 'Reset general settings (title, subtitle, and media) to defaults?';
        case 1:
          return 'Reset all features to defaults?';
        case 2:
          return 'Reset all testimonials to defaults?';
        case 3:
          return 'Reset instructor information to defaults?';
        case 4:
          return 'Reset course description to defaults?';
        case 5:
          return 'Reset all bonuses to defaults?';
        case 6:
          return 'Reset all colors and theme settings to defaults?';
        case 7:
          return 'Reset layout and section visibility to defaults?';
        case 8:
          return 'Reset badges and payment settings to defaults?';
        default:
          return 'Reset this section to defaults?';
      }
    })();

    const confirmReset = window.confirm(confirmMessage);
    
    if (confirmReset) {
      if (currentTab === 6) {
        // Reset colors and theme
        setStyles(defaultStyles);
        toast.success('Colors and theme have been reset to defaults');
      } else {
        // Reset content for the current tab
        const sectionsToReset = tabToSection[currentTab];
        const newContent = { ...content };
        
        sectionsToReset.forEach(section => {
          newContent[section] = defaultContent[section];
        });
        
        setContent(newContent);
        toast.success('Current tab has been reset to defaults');
      }
    }
  };

  const handleResetAll = () => {
    const confirmReset = window.confirm(
      'Are you sure you want to reset ALL content and styles to defaults? This will reset EVERY tab and cannot be undone.'
    );
    
    if (confirmReset) {
      // Double confirm for safety
      const doubleConfirm = window.confirm(
        'This will reset everything to default settings. Are you absolutely sure?'
      );
      
      if (doubleConfirm) {
        setContent(defaultContent);
        setStyles(defaultStyles);
        toast.success('All content and styles have been reset to defaults');
      }
    }
  };

  useEffect(() => {
    if (!content.features || content.features.length === 0) {
      setContent(prev => ({
        ...prev,
        features: defaultContent.features
      }));
    }
    if (!content.bonuses || content.bonuses.length === 0) {
      setContent(prev => ({
        ...prev,
        bonuses: defaultContent.bonuses
      }));
    }
  }, []);

  const ColorPickerButton = ({ color, onClick, label }) => (
    <div className={classes.colorButton} onClick={onClick}>
      <div 
        className={classes.colorPreview} 
        style={{ backgroundColor: color }}
      />
      <Typography style={{ color: 'white' }}>{label}</Typography>
    </div>
  );

  const handleMediaUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const storage = getStorage();
      const storageRef = ref(storage, `sales-page-media/${Date.now()}_${file.name}`);
      
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      
      setContent(prev => ({
        ...prev,
        mediaUrl: downloadURL,
        ...(content.mediaType === 'video' && file.type.startsWith('video/') && {
          videoPoster: '' // You might want to add a poster image upload option
        })
      }));
    } catch (error) {
      console.error('Error uploading media:', error);
      alert('Failed to upload media. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleTestimonialImageUpload = async (event, index) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const storage = getStorage();
      const storageRef = ref(storage, `testimonial-images/${Date.now()}_${file.name}`);
      
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      
      setContent(prev => ({
        ...prev,
        testimonials: prev.testimonials.map((t, i) => 
          i === index ? { ...t, image: downloadURL } : t
        )
      }));
    } catch (error) {
      console.error('Error uploading testimonial image:', error);
      alert('Failed to upload image. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleMediaUrlChange = (e) => {
    const url = e.target.value;
    setContent(prev => ({
      ...prev,
      mediaUrl: url,
      // Automatically set mediaType to video if it's a YouTube URL
      mediaType: url.includes('youtube.com/watch') || url.includes('youtu.be/') ? 'video' : prev.mediaType
    }));
  };

  const handleImageUpload = async (event) => {
    if (!event.target.files || !event.target.files[0]) return;
    
    try {
      setUploading(true);
      const file = event.target.files[0];
      const storage = getStorage();
      const timestamp = Date.now();
      const storageRef = ref(storage, `sales-page-backgrounds/${timestamp}_${file.name}`);
      
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);
      
      setStyles(prev => ({
        ...prev,
        backgroundType: 'image',
        backgroundImage: imageUrl,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }));
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setUploading(false);
    }
  };

  const handleTestimonialChange = (index, field, value) => {
    const newTestimonials = [...content.testimonials];
    newTestimonials[index] = {
      ...newTestimonials[index],
      [field]: value
    };
    setContent(prev => ({
      ...prev,
      testimonials: newTestimonials
    }));
  };

  const handleRemoveTestimonial = (index) => {
    const newTestimonials = content.testimonials.filter((_, i) => i !== index);
    setContent(prev => ({
      ...prev,
      testimonials: newTestimonials
    }));
  };

  const handleAddTestimonial = () => {
    const newTestimonial = {
      quote: '',
      author: '',
      level: '',
      image: '',
      rating: 5
    };
    setContent(prev => ({
      ...prev,
      testimonials: [...prev.testimonials, newTestimonial]
    }));
  };

  const handleColorChange = (colorType, color) => {
    setCurrentStyles(prev => {
      let newStyles = { ...prev };
      
      switch (colorType) {
        case 'textColor':
          newStyles.textColor = color.hex;
          break;
        case 'gradientStart':
          newStyles.gradientStart = color.hex;
          break;
        case 'gradientEnd':
          newStyles.gradientEnd = color.hex;
          break;
        case 'backgroundColor':
          newStyles.backgroundColor = color.hex;
          break;
        case 'overlayColor':
          newStyles.overlayColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
          break;
        case 'containerBackgroundColor':
          newStyles.containerBackgroundColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
          break;
        case 'title':
        case 'subtitle':
          newStyles.textColors = {
            ...(prev.textColors || {}),
            [colorType]: color.hex
          };
          break;
        default:
          break;
      }
      
      return newStyles;
    });
  };

  const handleBackgroundTypeChange = (event) => {
    const newType = event.target.value;
    setCurrentStyles(prev => ({
      ...prev,
      backgroundType: newType,
      // Reset relevant properties based on type
      ...(newType === 'gradient' && {
      gradientStart: prev.gradientStart || '#ff0000',
        gradientEnd: prev.gradientEnd || '#990000'
      }),
      ...(newType === 'solid' && {
        backgroundColor: prev.backgroundColor || '#ffffff'
      }),
      ...(newType === 'image' && {
      backgroundImage: prev.backgroundImage || ''
      })
    }));
  };

  const renderColorsAndTheme = () => {
    return (
      <div className={classes.tabContent}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Colors & Theme
        </Typography>
        
        <FormControl component="fieldset" className={classes.formControl}>
          <RadioGroup
            value={currentStyles.backgroundType || 'gradient'}
            onChange={handleBackgroundTypeChange}
          >
            <FormControlLabel value="gradient" control={<Radio />} label="Gradient Background" />
            <FormControlLabel value="solid" control={<Radio />} label="Solid Color" />
            <FormControlLabel value="image" control={<Radio />} label="Background Image" />
          </RadioGroup>

          {currentStyles.backgroundType === 'gradient' && (
            <div className={classes.colorPickers}>
              <div className={classes.colorPickerContainer}>
                <Button
                  variant="contained"
                  onClick={() => setShowGradientStartPicker(!showGradientStartPicker)}
                  style={{
                    backgroundColor: currentStyles.gradientStart || '#ff0000',
                    color: '#ffffff',
                    marginBottom: '10px'
                  }}
                >
                  Gradient Start Color
                </Button>
                {showGradientStartPicker && (
                  <div className={classes.popover}>
                    <div
                      className={classes.cover}
                      onClick={() => setShowGradientStartPicker(false)}
                    />
                    <ChromePicker
                      color={currentStyles.gradientStart || '#ff0000'}
                      onChange={(color) => handleColorChange('gradientStart', color)}
                    />
                  </div>
                )}
              </div>

              <div className={classes.colorPickerContainer}>
                <Button
                  variant="contained"
                  onClick={() => setShowGradientEndPicker(!showGradientEndPicker)}
                  style={{
                    backgroundColor: currentStyles.gradientEnd || '#990000',
                    color: '#ffffff',
                    marginBottom: '10px'
                  }}
                >
                  Gradient End Color
                </Button>
                {showGradientEndPicker && (
                  <div className={classes.popover}>
                    <div
                      className={classes.cover}
                      onClick={() => setShowGradientEndPicker(false)}
                    />
                    <ChromePicker
                      color={currentStyles.gradientEnd || '#990000'}
                      onChange={(color) => handleColorChange('gradientEnd', color)}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {currentStyles.backgroundType === 'solid' && (
            <div className={classes.colorPickerContainer}>
              <Button
                variant="contained"
                onClick={() => setShowSolidColorPicker(!showSolidColorPicker)}
                style={{
                  backgroundColor: currentStyles.backgroundColor || '#ffffff',
                  color: '#000000',
                  marginBottom: '10px'
                }}
              >
                Background Color
              </Button>
              {showSolidColorPicker && (
                <div className={classes.popover}>
                  <div
                    className={classes.cover}
                    onClick={() => setShowSolidColorPicker(false)}
                  />
                  <ChromePicker
                    color={currentStyles.backgroundColor || '#ffffff'}
                    onChange={(color) => handleColorChange('backgroundColor', color)}
                  />
                </div>
              )}
            </div>
          )}

          {currentStyles.backgroundType === 'image' && (
            <Box mt={2}>
              <input
                accept="image/*"
                style={{ display: 'none' }}
                id="background-image-upload"
                type="file"
                onChange={async (e) => {
                  if (e.target.files?.[0]) {
                    const file = e.target.files[0];
                    const storage = getStorage();
                    const timestamp = Date.now();
                    const storageRef = ref(storage, `backgrounds/${timestamp}_${file.name}`);
                    
                    try {
                      const snapshot = await uploadBytes(storageRef, file);
                      const downloadURL = await getDownloadURL(snapshot.ref);
                      setCurrentStyles(prev => ({
                        ...prev,
                        backgroundImage: downloadURL
                      }));
                    } catch (error) {
                      console.error('Error uploading background image:', error);
                      // Handle error appropriately
                    }
                  }
                }}
              />
              <label htmlFor="background-image-upload">
                <Button
                  variant="contained"
                  component="span"
                  className={classes.uploadButton}
                >
                  Upload Background Image
                </Button>
              </label>
              {currentStyles.backgroundImage && (
                <img 
                  src={currentStyles.backgroundImage} 
                  alt="Background Preview" 
                  className={classes.uploadPreview}
                />
              )}
            </Box>
          )}

          <div className={classes.colorControl}>
            <Typography gutterBottom style={{ color: 'white' }}>Overlay Color & Opacity</Typography>
            <div className={classes.colorButton} onClick={() => setShowOverlayColorPicker(!showOverlayColorPicker)}>
              <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.overlayColor }} />
              <Typography style={{ color: 'white' }}>Select Color</Typography>
            </div>
            {showOverlayColorPicker && (
              <div className={classes.colorPickerPopover}>
                <ChromePicker
                  color={currentStyles.overlayColor}
                  onChange={(color) => handleColorChange('overlayColor', color)}
                />
              </div>
            )}
          </div>

          <div className={classes.colorControl}>
            <Typography gutterBottom style={{ color: 'white' }}>Container Background Color</Typography>
            <div className={classes.colorButton} onClick={() => setShowContainerColorPicker(!showContainerColorPicker)}>
              <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.containerBackgroundColor }} />
              <Typography style={{ color: 'white' }}>Select Color</Typography>
            </div>
            {showContainerColorPicker && (
              <div className={classes.colorPickerPopover}>
                <ChromePicker
                  color={currentStyles.containerBackgroundColor}
                  onChange={(color) => handleColorChange('containerBackgroundColor', color)}
                />
              </div>
            )}
          </div>

          <div className={classes.colorControl}>
            <Typography gutterBottom style={{ color: 'white' }}>Global Text Color</Typography>
            <div className={classes.colorButton} onClick={() => setShowTextColorPicker(!showTextColorPicker)}>
              <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.textColor }} />
              <Typography style={{ color: 'white' }}>Select Color</Typography>
            </div>
            {showTextColorPicker && (
              <div className={classes.colorPickerPopover}>
                <ChromePicker
                  color={currentStyles.textColor}
                  onChange={(color) => handleColorChange('textColor', color)}
                />
              </div>
            )}
          </div>

          <div className={classes.colorControl}>
            <Typography gutterBottom style={{ color: 'white' }}>Title & Subtitle Color (Optional Override)</Typography>
            <div className={classes.colorButton} onClick={() => setShowTitleColorPicker(!showTitleColorPicker)}>
              <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.textColors?.title || currentStyles.textColor || '#ffffff' }} />
              <Typography style={{ color: 'white' }}>Select Color</Typography>
            </div>
            {showTitleColorPicker && (
              <div className={classes.colorPickerPopover}>
                <ChromePicker
                  color={currentStyles.textColors?.title || currentStyles.textColor || '#ffffff'}
                  onChange={(color) => handleColorChange('title', color)}
                />
              </div>
            )}
          </div>
        </FormControl>
      </div>
    );
  };

  const handleViewLive = () => {
    window.open('/sales', '_blank');
  };

  const handleViewStaging = () => {
    window.open('/sales/preview', '_blank');
  };

  return (
    <div className={classes.root}>
      <div className={classes.mainContent}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="contained"
                color={currentVersion === 'live' ? 'primary' : 'default'}
                onClick={() => setCurrentVersion('live')}
              >
                Live Version
              </Button>
              <Button
                variant="contained"
                color={currentVersion === 'staging' ? 'primary' : 'default'}
                onClick={() => setCurrentVersion('staging')}
              >
                Staging Version
              </Button>
            </div>
            <div className={classes.viewButtons}>
              <Button
                variant="contained"
                className={classes.viewButton}
                onClick={handleViewLive}
                startIcon={<OpenInNewIcon />}
              >
                View Live
              </Button>
              <Button
                variant="contained"
                className={classes.viewButton}
                onClick={handleViewStaging}
                startIcon={<OpenInNewIcon />}
              >
                View Staging
              </Button>
            </div>
          </div>
          {currentVersion === 'staging' && (
            <Button
              variant="contained"
              color="secondary"
              onClick={handlePromoteToLive}
            >
              Promote to Live
            </Button>
          )}
        </div>

        {currentVersion === 'live' && (
          <div className={classes.salesPageToggle}>
            <Typography variant="subtitle1" style={{ color: 'white', marginBottom: '10px' }}>
              Sales Page Version
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={!content.useNewSalesPage}
                  onChange={async (e) => {
                    const newValue = e.target.checked;
                    try {
                      const db = getFirestore();
                      await setDoc(doc(db, 'siteConfig', 'salesPageSettings'), {
                        useNewSalesPage: !newValue
                      }, { merge: true });
                      
                      setCurrentContent(prev => ({
                        ...prev,
                        useNewSalesPage: !newValue
                      }));
                      
                      toast.success(`Now using ${newValue ? 'legacy' : 'new'} sales page`);
                    } catch (error) {
                      console.error('Error updating sales page version:', error);
                      toast.error('Failed to update sales page version');
                    }
                  }}
                />
              }
              label="Use Legacy Sales Page"
            />
            <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.7)', marginTop: '5px' }}>
              When enabled, users will be directed to the legacy sales page instead of this one
            </Typography>
          </div>
        )}

        <div className={classes.tabsContainer}>
          <Tabs
            orientation="vertical"
            value={currentTab}
            onChange={handleTabChange}
            aria-label="sales page customizer tabs"
            className={classes.tabs}
            indicatorColor="primary"
          >
            <Tab label="General" />
            <Tab label="Features" />
            <Tab label="Testimonials" />
            <Tab label="Instructor" />
            <Tab label="Course Description" />
            <Tab label="Bonuses" />
            <Tab label="Colors & Theme" />
            <Tab label="Layout" />
            <Tab label="Badges & Payment" />
          </Tabs>

          <Box className={classes.tabPanel}>
            <TabPanel value={currentTab} index={0} className={classes.tabPanel}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Header Settings
              </Typography>

              <div className={classes.section}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={currentContent?.logo?.enabled || false}
                      onChange={(e) => handleContentChange('logo', {
                        ...currentContent.logo,
                        enabled: e.target.checked
                      })}
                      name="logoEnabled"
                    />
                  }
                  label="Show Logo"
                  style={{ color: 'white', marginBottom: '20px' }}
                />

                {currentContent?.logo?.enabled && (
                  <>
                    <TextField
                      className={classes.textField}
                      fullWidth
                      label="Logo URL"
                      value={currentContent?.logo?.url || ''}
                      onChange={(e) => handleContentChange('logo', {
                        ...currentContent.logo,
                        url: e.target.value
                      })}
                      variant="outlined"
                      margin="dense"
                      helperText="Enter logo image URL or upload an image"
                    />

                    <input
                      accept="image/*"
                      style={{ display: 'none' }}
                      id="logo-upload"
                      type="file"
                      onChange={async (e) => {
                        if (e.target.files?.[0]) {
                          const file = e.target.files[0];
                          try {
                            toast.loading('Uploading logo...');
                            const storage = getStorage();
                            const storageRef = ref(storage, `sales-page/logo-${Date.now()}`);
                            
                            await uploadBytes(storageRef, file);
                            const downloadURL = await getDownloadURL(storageRef);
                            
                            handleContentChange('logo', {
                              ...currentContent.logo,
                              url: downloadURL
                            });
                            toast.dismiss();
                            toast.success('Logo uploaded successfully');
                          } catch (error) {
                            console.error('Error uploading logo:', error);
                            toast.dismiss();
                            toast.error('Failed to upload logo');
                          }
                        }
                      }}
                    />
                    <label htmlFor="logo-upload">
                      <Button
                        variant="contained"
                        component="span"
                        className={classes.uploadButton}
                      >
                        Upload Logo
                      </Button>
                    </label>

                    <FormControl component="fieldset" className={classes.formControl}>
                      <FormLabel component="legend" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Logo Position</FormLabel>
                      <RadioGroup
                        value={currentContent?.logo?.position || 'above'}
                        onChange={(e) => handleContentChange('logo', {
                          ...currentContent.logo,
                          position: e.target.value
                        })}
                      >
                        <FormControlLabel value="above" control={<Radio />} label="Above Header" />
                        <FormControlLabel value="between" control={<Radio />} label="Between Header and Subheader" />
                        <FormControlLabel value="below" control={<Radio />} label="Below Subheader" />
                      </RadioGroup>
                    </FormControl>

                    <TextField
                      className={classes.textField}
                      label="Logo Max Width"
                      value={currentContent?.logo?.maxWidth || '200px'}
                      onChange={(e) => handleContentChange('logo', {
                        ...currentContent.logo,
                        maxWidth: e.target.value
                      })}
                      variant="outlined"
                      margin="dense"
                      helperText="Enter value in px, rem, or %. Default: 200px"
                    />

                    <TextField
                      className={classes.textField}
                      label="Logo Top Margin"
                      value={currentContent?.logo?.marginTop || '20px'}
                      onChange={(e) => handleContentChange('logo', {
                        ...currentContent.logo,
                        marginTop: e.target.value
                      })}
                      variant="outlined"
                      margin="dense"
                      helperText="Enter value in px, rem, or %. Default: 20px"
                    />

                    <TextField
                      className={classes.textField}
                      label="Logo Bottom Margin"
                      value={currentContent?.logo?.marginBottom || '20px'}
                      onChange={(e) => handleContentChange('logo', {
                        ...currentContent.logo,
                        marginBottom: e.target.value
                      })}
                      variant="outlined"
                      margin="dense"
                      helperText="Enter value in px, rem, or %. Default: 20px"
                    />

                    {currentContent?.logo?.url && (
                      <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Typography variant="subtitle2" style={{ color: 'white', marginBottom: '10px' }}>
                          Logo Preview
                        </Typography>
                        <img
                          src={currentContent.logo.url}
                          alt="Logo Preview"
                          style={{
                            maxWidth: '200px',
                            maxHeight: '100px',
                            objectFit: 'contain'
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>

              <TextField
                className={classes.textField}
                fullWidth
                label="Title"
                value={currentContent?.title || ''}
                onChange={(e) => handleContentChange('title', undefined, e.target.value)}
                variant="outlined"
                margin="dense"
              />
              <TextField
                className={classes.textField}
                fullWidth
                label="Subtitle"
                value={currentContent?.subtitle || ''}
                onChange={(e) => handleContentChange('subtitle', undefined, e.target.value)}
                variant="outlined"
                margin="dense"
              />
              <div className={classes.colorControl}>
                <Typography gutterBottom style={{ color: 'white' }}>Title Color</Typography>
                <div className={classes.colorButton} onClick={() => setShowTitleColorPicker(!showTitleColorPicker)}>
                  <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.textColors?.title || '#ffffff' }} />
                  <Typography style={{ color: 'white' }}>Select Color</Typography>
                </div>
                {showTitleColorPicker && (
                  <div className={classes.colorPickerPopover}>
                    <ChromePicker
                      color={currentStyles.textColors?.title || '#ffffff'}
                      onChange={(color) => {
                        setCurrentStyles(prev => ({
                          ...prev,
                          textColors: { ...(prev.textColors || {}), title: color.hex }
                        }));
                      }}
                    />
                  </div>
                )}
              </div>

              <div className={classes.colorControl}>
                <Typography gutterBottom style={{ color: 'white' }}>Subtitle Color</Typography>
                <div className={classes.colorButton} onClick={() => setShowSubtitleColorPicker(!showSubtitleColorPicker)}>
                  <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.textColors?.subtitle || '#ffffff' }} />
                  <Typography style={{ color: 'white' }}>Select Color</Typography>
                </div>
                {showSubtitleColorPicker && (
                  <div className={classes.colorPickerPopover}>
                    <ChromePicker
                      color={currentStyles.textColors?.subtitle || '#ffffff'}
                      onChange={(color) => {
                        setCurrentStyles(prev => ({
                          ...prev,
                          textColors: { ...(prev.textColors || {}), subtitle: color.hex }
                        }));
                      }}
                    />
                  </div>
                )}
              </div>
              
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Media Type</FormLabel>
                <RadioGroup
                  value={content.mediaType || 'video'}
                  onChange={(e) => handleContentChange('mediaType', null, e.target.value)}
                >
                  <FormControlLabel value="video" control={<Radio />} label="Video" />
                  <FormControlLabel value="image" control={<Radio />} label="Image" />
                </RadioGroup>
              </FormControl>

              {content.mediaType === 'video' ? (
                <>
                  <TextField
                    fullWidth
                    label="Video URL"
                    variant="outlined"
                    value={content.mediaUrl || ''}
                    onChange={(e) => handleContentChange('mediaUrl', null, e.target.value)}
                    className={classes.textField}
                    helperText="Enter YouTube URL or upload a video"
                  />
                  <input
                    accept="video/*"
                    style={{ display: 'none' }}
                    id="video-upload"
                    type="file"
                    onChange={async (e) => {
                      if (e.target.files?.[0]) {
                        const file = e.target.files[0];
                        const storage = getStorage();
                        const timestamp = Date.now();
                        const storageRef = ref(storage, `videos/${timestamp}_${file.name}`);
                        
                        try {
                          const snapshot = await uploadBytes(storageRef, file);
                          const downloadURL = await getDownloadURL(snapshot.ref);
                          handleContentChange('mediaUrl', null, downloadURL);
                        } catch (error) {
                          console.error('Error uploading video:', error);
                          // Handle error appropriately
                        }
                      }
                    }}
                  />
                  <label htmlFor="video-upload">
                    <Button
                      variant="contained"
                      component="span"
                      className={classes.uploadButton}
                    >
                      Upload Video
                    </Button>
                  </label>
                </>
              ) : (
                <>
                  <TextField
                    fullWidth
                    label="Image URL"
                    variant="outlined"
                    value={content.mediaUrl || ''}
                    onChange={(e) => handleContentChange('mediaUrl', null, e.target.value)}
                    className={classes.textField}
                    helperText="Enter image URL or upload an image"
                  />
                  <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="image-upload"
                    type="file"
                    onChange={async (e) => {
                      if (e.target.files?.[0]) {
                        const file = e.target.files[0];
                        const storage = getStorage();
                        const timestamp = Date.now();
                        const storageRef = ref(storage, `images/${timestamp}_${file.name}`);
                        
                        try {
                          const snapshot = await uploadBytes(storageRef, file);
                          const downloadURL = await getDownloadURL(snapshot.ref);
                          handleContentChange('mediaUrl', null, downloadURL);
                        } catch (error) {
                          console.error('Error uploading image:', error);
                          // Handle error appropriately
                        }
                      }
                    }}
                  />
                  <label htmlFor="image-upload">
                    <Button
                      variant="contained"
                      component="span"
                      className={classes.uploadButton}
                    >
                      Upload Image
                    </Button>
                  </label>
                </>
              )}
              {content.mediaUrl && (content.mediaType === 'image' ? (
                <img 
                  src={content.mediaUrl} 
                  alt="Media Preview" 
                  className={classes.uploadPreview}
                />
              ) : (
                <video 
                  src={content.mediaUrl} 
                  controls 
                  className={classes.uploadPreview}
                />
              ))}
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <Typography variant="h6" className={classes.sectionTitle}>Course Features</Typography>
              {(Array.isArray(content?.features) ? content.features : []).map((feature, index) => (
                <Box key={index} mb={2} p={2} border="1px solid rgba(255, 255, 255, 0.23)" borderRadius="4px">
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Feature Title"
                    value={feature?.title || ''}
                    onChange={(e) => {
                      const newFeatures = [...(content.features || [])];
                      newFeatures[index] = { ...newFeatures[index], title: e.target.value };
                      handleContentChange('features', null, newFeatures);
                    }}
                    variant="outlined"
                    margin="dense"
                  />
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Feature Description"
                    value={feature?.description || ''}
                    onChange={(e) => {
                      const newFeatures = [...(content.features || [])];
                      newFeatures[index] = { ...newFeatures[index], description: e.target.value };
                      handleContentChange('features', null, newFeatures);
                    }}
                    variant="outlined"
                    margin="dense"
                    multiline
                    rows={4}
                  />
                  <Box mt={1} display="flex" justifyContent="flex-end">
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        const newFeatures = (content.features || []).filter((_, i) => i !== index);
                        handleContentChange('features', null, newFeatures);
                      }}
                      style={{ color: '#ff4444', borderColor: '#ff4444' }}
                    >
                      Remove Feature
                    </Button>
                  </Box>
                </Box>
              ))}
              <Button
                variant="outlined"
                style={{ color: 'white', borderColor: 'rgba(255, 255, 255, 0.23)' }}
                onClick={() => {
                  const newFeatures = [...(content.features || []), { title: '', description: '' }];
                  handleContentChange('features', null, newFeatures);
                }}
              >
                Add Feature
              </Button>
              <div className={classes.colorControl}>
                <Typography gutterBottom style={{ color: 'white' }}>Features Text Color</Typography>
                <div className={classes.colorButton} onClick={() => setShowFeaturesColorPicker(!showFeaturesColorPicker)}>
                  <div className={classes.colorPreview} style={{ backgroundColor: currentStyles.textColors.features }} />
                  <Typography style={{ color: 'white' }}>Select Color</Typography>
                </div>
                {showFeaturesColorPicker && (
                  <div className={classes.colorPickerPopover}>
                    <ChromePicker
                      color={currentStyles.textColors.features}
                      onChange={(color) => {
                        setCurrentStyles(prev => ({
                          ...prev,
                          textColors: { ...prev.textColors, features: color.hex }
                        }));
                      }}
                    />
                  </div>
                )}
              </div>
            </TabPanel>

            <TabPanel value={currentTab} index={2}>
              <div className={classes.tabContent}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Video Testimonials Section
                </Typography>
                
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Section Heading (Optional)"
                  value={content.testimonialSection?.heading || ''}
                  onChange={(e) => handleContentChange('testimonialSection', {
                    ...content.testimonialSection,
                    heading: e.target.value
                  })}
                  variant="outlined"
                  margin="dense"
                  helperText="Leave empty to hide the heading"
                />

                    <TextField
                      className={classes.textField}
                      fullWidth
                  label="Section Subtext (Optional)"
                  value={content.testimonialSection?.subtext || ''}
                  onChange={(e) => handleContentChange('testimonialSection', {
                    ...content.testimonialSection,
                    subtext: e.target.value
                  })}
                  variant="outlined"
                  margin="dense"
                  multiline
                  rows={3}
                  helperText="Text to display below the heading and above the testimonials"
                />

                <Typography variant="h6" className={classes.sectionTitle} style={{ marginTop: '20px' }}>
                  Testimonial Videos
                </Typography>

                <div className={classes.testimonialsList}>
                  {content.testimonials?.map((testimonial, index) => (
                    <Card key={index} className={classes.testimonialCard}>
                      <CardContent>
                        <div className={classes.videoUploadSection}>
                        <TextField
                            label="Testimonial Header (Optional)"
                            value={testimonial.header || ''}
                            onChange={(e) => {
                              const newTestimonials = [...content.testimonials];
                              newTestimonials[index] = {
                                ...newTestimonials[index],
                                header: e.target.value
                              };
                              handleContentChange('testimonials', null, newTestimonials);
                            }}
                          fullWidth
                          margin="normal"
                            helperText="Text to display above the video (optional)"
                        />

                        <TextField
                            label="Video URL (YouTube)"
                            value={testimonial.videoUrl || ''}
                            onChange={(e) => {
                              const newTestimonials = [...content.testimonials];
                              newTestimonials[index] = {
                                ...newTestimonials[index],
                                videoUrl: e.target.value
                              };
                              handleContentChange('testimonials', null, newTestimonials);
                            }}
                          fullWidth
                          margin="normal"
                            helperText="Enter a YouTube video URL or upload a video file"
                          />

                          <div className={classes.uploadButtons}>
                            <input
                              accept="video/*"
                              type="file"
                              id={`testimonial-video-${index}`}
                              style={{ display: 'none' }}
                              onChange={async (e) => {
                                if (e.target.files?.[0]) {
                                  const file = e.target.files[0];
                                  
                                  // Check file size (limit to 100MB)
                                  if (file.size > 100 * 1024 * 1024) {
                                    toast.error('Video file size must be less than 100MB');
                                    return;
                                  }

                                  try {
                                    toast.loading('Uploading video...');
                                    const storage = getStorage();
                                    const storageRef = ref(storage, `testimonial-videos/${Date.now()}_${file.name}`);
                                    
                                    await uploadBytes(storageRef, file);
                                    const downloadURL = await getDownloadURL(storageRef);
                                    
                                    const newTestimonials = [...content.testimonials];
                                    newTestimonials[index] = {
                                      ...newTestimonials[index],
                                      videoUrl: downloadURL
                                    };
                                    handleContentChange('testimonials', null, newTestimonials);
                                    toast.dismiss();
                                    toast.success('Video uploaded successfully');
                                  } catch (error) {
                                    console.error('Error uploading video:', error);
                                    toast.dismiss();
                                    toast.error('Failed to upload video');
                                  }
                                }
                              }}
                            />
                            <label htmlFor={`testimonial-video-${index}`}>
                              <Button
                                variant="contained"
                                component="span"
                                className={classes.uploadButton}
                              >
                                Upload Video
                              </Button>
                            </label>

                          <input
                            accept="image/*"
                            type="file"
                              id={`testimonial-thumbnail-${index}`}
                            style={{ display: 'none' }}
                              onChange={async (e) => {
                                if (e.target.files?.[0]) {
                                  const file = e.target.files[0];
                                  try {
                                    toast.loading('Uploading thumbnail...');
                                    const storage = getStorage();
                                    const storageRef = ref(storage, `testimonial-thumbnails/${Date.now()}_${file.name}`);
                                    
                                    await uploadBytes(storageRef, file);
                                    const downloadURL = await getDownloadURL(storageRef);
                                    
                                    const newTestimonials = [...content.testimonials];
                                    newTestimonials[index] = {
                                      ...newTestimonials[index],
                                      thumbnail: downloadURL
                                    };
                                    handleContentChange('testimonials', null, newTestimonials);
                                    toast.dismiss();
                                    toast.success('Thumbnail uploaded successfully');
                                  } catch (error) {
                                    console.error('Error uploading thumbnail:', error);
                                    toast.dismiss();
                                    toast.error('Failed to upload thumbnail');
                                  }
                                }
                              }}
                            />
                            <label htmlFor={`testimonial-thumbnail-${index}`}>
                            <Button
                              variant="contained"
                              component="span"
                              className={classes.uploadButton}
                            >
                                Upload Thumbnail
                            </Button>
                          </label>
                          </div>

                          <Typography variant="caption" style={{ color: '#666', display: 'block', marginTop: '8px' }}>
                            Note: Custom thumbnails can only be added to directly uploaded videos, not YouTube videos. YouTube videos will use their default thumbnails.
                          </Typography>

                          <TextField
                            label="Testimonial Subtext (Optional)"
                            value={testimonial.subtext || ''}
                            onChange={(e) => {
                              const newTestimonials = [...content.testimonials];
                              newTestimonials[index] = {
                                ...newTestimonials[index],
                                subtext: e.target.value
                              };
                              handleContentChange('testimonials', null, newTestimonials);
                            }}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={3}
                            helperText="Text to display below the video (optional)"
                          />

                          {testimonial.thumbnail && (
                            <div className={classes.previewSection}>
                              <Typography variant="subtitle2" style={{ color: 'white', marginBottom: '8px' }}>
                                Thumbnail Preview:
                              </Typography>
                              <img
                                src={testimonial.thumbnail}
                                alt="Thumbnail Preview"
                                className={classes.thumbnailPreview}
                              />
                            </div>
                          )}

                          <div className={classes.videoPreview}>
                            {testimonial.videoUrl && (
                              <>
                                <Typography variant="subtitle2" style={{ color: 'white', marginBottom: '8px' }}>
                                  Video Preview:
                                </Typography>
                                <div className={classes.videoWrapper}>
                                  {testimonial.videoUrl.includes('youtube.com') || testimonial.videoUrl.includes('youtu.be') ? (
                                    <iframe
                                      src={getYouTubeEmbedUrl(testimonial.videoUrl)}
                                      title={`Testimonial ${index + 1}`}
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                    />
                                  ) : (
                                    <video
                                      src={testimonial.videoUrl}
                                      controls
                                      style={{ width: '100%', borderRadius: '4px' }}
                            />
                          )}
                        </div>
                              </>
                            )}
                          </div>
                        </div>

                        <Button
                          onClick={() => {
                            const newTestimonials = content.testimonials.filter((_, i) => i !== index);
                            handleContentChange('testimonials', null, newTestimonials);
                          }}
                          color="secondary"
                        >
                          Remove Testimonial
                        </Button>
                      </CardContent>
                    </Card>
                  ))}
                  <Button
                    onClick={() => {
                      const newTestimonials = [
                        ...content.testimonials,
                        { videoUrl: '', thumbnail: '', header: '', subtext: '' }
                      ];
                      handleContentChange('testimonials', null, newTestimonials);
                    }}
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                  >
                    Add Video Testimonial
                  </Button>
                </div>
              </div>
            </TabPanel>

            <TabPanel value={currentTab} index={3}>
              <Typography variant="h6" className={classes.sectionTitle}>
                About the Instructor
              </Typography>
              
              <TextField
                className={classes.textField}
                fullWidth
                label="Section Title"
                value={content.instructor?.title || ''}
                onChange={(e) => handleContentChange('instructor', {
                  ...content.instructor,
                  title: e.target.value
                })}
                variant="outlined"
                margin="dense"
                helperText="The title of the instructor section (e.g. '🎓 About Your Instructor – Hector Castillo')"
                FormHelperTextProps={{
                  style: { color: 'rgba(255, 255, 255, 0.7)' }
                }}
              />

              <div style={{ marginTop: '20px' }}>
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Instructor Image URL"
                  value={content.instructor?.image || ''}
                  onChange={(e) => handleContentChange('instructor', {
                    ...content.instructor,
                    image: e.target.value
                  })}
                  variant="outlined"
                  margin="dense"
                  helperText="URL of the instructor's profile image"
                  FormHelperTextProps={{
                    style: { color: 'rgba(255, 255, 255, 0.7)' }
                  }}
                />

                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="instructor-image-upload"
                  type="file"
                  onChange={async (e) => {
                    if (e.target.files?.[0]) {
                      const file = e.target.files[0];
                      try {
                        toast.loading('Uploading image...');
                        const storage = getStorage();
                        const storageRef = ref(storage, `instructor/${Date.now()}_${file.name}`);
                        
                        await uploadBytes(storageRef, file);
                        const downloadURL = await getDownloadURL(storageRef);
                        
                        handleContentChange('instructor', {
                          ...content.instructor,
                          image: downloadURL
                        });
                        toast.dismiss();
                        toast.success('Image uploaded successfully');
                      } catch (error) {
                        console.error('Error uploading image:', error);
                        toast.dismiss();
                        toast.error('Failed to upload image');
                      }
                    }
                  }}
                />
                <label htmlFor="instructor-image-upload">
                  <Button
                    variant="contained"
                    component="span"
                    className={classes.uploadButton}
                  >
                    Upload Image
                  </Button>
                </label>
              </div>

              <TextField
                className={classes.textField}
                fullWidth
                multiline
                rows={6}
                label="Instructor Bio"
                value={content.instructor?.bio || ''}
                onChange={(e) => handleContentChange('instructor', {
                  ...content.instructor,
                  bio: e.target.value
                })}
                variant="outlined"
                margin="dense"
                helperText="The main biography text for the instructor"
                FormHelperTextProps={{
                  style: { color: 'rgba(255, 255, 255, 0.7)' }
                }}
              />

              <Typography variant="subtitle1" style={{ color: 'white', marginTop: '20px', marginBottom: '10px' }}>
                Achievements
              </Typography>
              
              {(content.instructor?.achievements || []).map((achievement, index) => (
                <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                  <TextField
                    className={classes.textField}
                    fullWidth
                    value={achievement}
                    onChange={(e) => {
                      const newAchievements = [...(content.instructor?.achievements || [])];
                      newAchievements[index] = e.target.value;
                      handleContentChange('instructor', {
                        ...content.instructor,
                        achievements: newAchievements
                      });
                    }}
                    variant="outlined"
                    margin="dense"
                  />
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      const newAchievements = (content.instructor?.achievements || []).filter((_, i) => i !== index);
                      handleContentChange('instructor', {
                        ...content.instructor,
                        achievements: newAchievements
                      });
                    }}
                    style={{ minWidth: '40px', marginTop: '8px' }}
                  >
                    ✕
                  </Button>
                </div>
              ))}
              
              <Button
                variant="outlined"
                style={{ color: 'white', borderColor: 'rgba(255, 255, 255, 0.23)', marginTop: '10px' }}
                onClick={() => {
                  const newAchievements = [...(content.instructor?.achievements || []), ''];
                  handleContentChange('instructor', {
                    ...content.instructor,
                    achievements: newAchievements
                  });
                }}
              >
                Add Achievement
              </Button>
            </TabPanel>

            <TabPanel value={currentTab} index={4}>
              <Typography variant="h6" className={classes.sectionTitle}>Course Description</Typography>
              
              <TextField
                className={classes.textField}
                fullWidth
                label="Main Heading"
                value={content.courseDescription?.mainHeading || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  mainHeading: e.target.value
                })}
                variant="outlined"
                margin="dense"
                helperText="The main heading for the course description"
              />

              <TextField
                className={classes.textField}
                fullWidth
                label="Overview"
                value={content.courseDescription?.overview || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  overview: e.target.value
                })}
                variant="outlined"
                margin="dense"
                multiline
                rows={4}
                helperText="A brief overview of the course"
              />

              <TextField
                className={classes.textField}
                fullWidth
                label={'What is "Meet Girls Everywhere"?'}
                value={content.courseDescription?.whatIs?.heading || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  whatIs: {
                    ...content.courseDescription?.whatIs,
                    heading: e.target.value
                  }
                })}
                variant="outlined"
                margin="dense"
                helperText={'The heading for the "What is Meet Girls Everywhere?" section'}
              />

              <TextField
                className={classes.textField}
                fullWidth
                label={'What is "Meet Girls Everywhere"? Content'}
                value={content.courseDescription?.whatIs?.content || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  whatIs: {
                    ...content.courseDescription?.whatIs,
                    content: e.target.value
                  }
                })}
                variant="outlined"
                margin="dense"
                multiline
                rows={4}
                helperText={'The content for the "What is Meet Girls Everywhere?" section'}
              />

              <TextField
                className={classes.textField}
                fullWidth
                label="Ready to Get Started Heading"
                value={content.courseDescription?.readyToStart?.heading || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  readyToStart: {
                    ...content.courseDescription?.readyToStart,
                    heading: e.target.value
                  }
                })}
                variant="outlined"
                margin="dense"
                helperText="The heading for the 'Ready to Get Started' section"
              />

              <TextField
                className={classes.textField}
                fullWidth
                label="Ready to Get Started Content"
                value={content.courseDescription?.readyToStart?.content || ''}
                onChange={(e) => handleContentChange('courseDescription', {
                  ...content.courseDescription,
                  readyToStart: {
                    ...content.courseDescription?.readyToStart,
                    content: e.target.value
                  }
                })}
                variant="outlined"
                margin="dense"
                multiline
                rows={4}
                helperText="The content for the 'Ready to Get Started' section"
              />
            </TabPanel>

            <TabPanel value={currentTab} index={5}>
              <Typography variant="h6" className={classes.sectionTitle}>Course Bonuses</Typography>
              {(Array.isArray(content?.bonuses) ? content.bonuses : []).map((bonus, index) => (
                <Box key={index} mb={2} p={2} border="1px solid rgba(255, 255, 255, 0.23)" borderRadius="4px">
                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Bonus Title"
                    value={bonus?.title || ''}
                    onChange={(e) => {
                      const newBonuses = [...(content.bonuses || [])];
                      newBonuses[index] = { ...newBonuses[index], title: e.target.value };
                      handleContentChange('bonuses', null, newBonuses);
                    }}
                    variant="outlined"
                    margin="dense"
                  />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '10px' }}>
                  <TextField
                    className={classes.textField}
                    type="number"
                    label="Original Price ($)"
                      value={bonus?.originalPrice || ''}
                    onChange={(e) => {
                        const newBonuses = [...(content.bonuses || [])];
                        newBonuses[index] = { ...newBonuses[index], originalPrice: parseFloat(e.target.value) };
                      handleContentChange('bonuses', null, newBonuses);
                    }}
                    variant="outlined"
                    margin="dense"
                      style={{ flex: 1 }}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={bonus?.showOriginalPrice ?? true}
                          onChange={(e) => {
                            const newBonuses = [...(content.bonuses || [])];
                            newBonuses[index] = { ...newBonuses[index], showOriginalPrice: e.target.checked };
                            handleContentChange('bonuses', null, newBonuses);
                          }}
                          name={`show-price-${index}`}
                        />
                      }
                      label="Show Price"
                      style={{ color: 'white', marginBottom: '16px' }}
                    />
                  </div>
                <TextField
                  className={classes.textField}
                  fullWidth
                    label="Description"
                    value={bonus?.description || ''}
                    onChange={(e) => {
                      const newBonuses = [...(content.bonuses || [])];
                      newBonuses[index] = { ...newBonuses[index], description: e.target.value };
                      handleContentChange('bonuses', null, newBonuses);
                    }}
                  variant="outlined"
                    margin="dense"
                    multiline
                    rows={4}
                  />
                  <Box mt={1} display="flex" justifyContent="flex-end">
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        const newBonuses = content.bonuses.filter((_, i) => i !== index);
                        handleContentChange('bonuses', null, newBonuses);
                      }}
                      style={{ color: '#ff4444', borderColor: '#ff4444' }}
                    >
                      Remove Bonus
                    </Button>
                  </Box>
                </Box>
              ))}
              <Button
                variant="outlined"
                style={{ color: 'white', borderColor: 'rgba(255, 255, 255, 0.23)' }}
                onClick={() => {
                  const newBonuses = [...content.bonuses, { 
                    title: '', 
                    originalPrice: 0, 
                    description: '',
                    showOriginalPrice: true 
                  }];
                  handleContentChange('bonuses', null, newBonuses);
                }}
              >
                Add Bonus
              </Button>
            </TabPanel>

            <TabPanel value={currentTab} index={6}>
              {renderColorsAndTheme()}
            </TabPanel>

            <TabPanel value={currentTab} index={7}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Layout and Section Order
              </Typography>
              <SectionVisibilityControls content={content} onContentChange={handleContentChange} />
              <Divider className={classes.divider} />
              
              <Typography variant="subtitle1" className={classes.subsectionTitle}>
                Section Order
                </Typography>
              <DraggableSectionList
                sections={content.sectionOrder?.left || defaultContent.sectionOrder.left}
                onReorder={(newOrder, side) => {
                  setCurrentContent(prev => ({
                    ...prev,
                    sectionOrder: {
                      ...prev.sectionOrder,
                      [side]: newOrder
                    }
                  }));
                }}
                side="left"
              />
              <Divider className={classes.divider} />
              <DraggableSectionList
                sections={content.sectionOrder?.right || defaultContent.sectionOrder.right}
                onReorder={(newOrder, side) => {
                  setCurrentContent(prev => ({
                    ...prev,
                    sectionOrder: {
                      ...prev.sectionOrder,
                      [side]: newOrder
                    }
                  }));
                }}
                side="right"
              />
            </TabPanel>

            <TabPanel value={currentTab} index={8}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Badges & Payment Settings
              </Typography>
              
              <BadgeManager 
                badges={content.badges || defaultContent.badges} 
                onChange={(newBadges) => handleContentChange('badges', null, newBadges)} 
              />
            </TabPanel>
          </Box>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <Button
          variant="contained"
            onClick={handleResetTab}
            style={{ backgroundColor: 'rgba(255, 0, 0, 0.2)' }}
          >
            Reset Current Tab
          </Button>
          <Button
            variant="contained"
            onClick={handleResetAll}
            style={{ backgroundColor: 'rgba(255, 0, 0, 0.4)' }}
          >
            Reset All Tabs
          </Button>
          <Button
            variant="contained"
            color="primary"
          onClick={handleSave}
        >
            Save {currentVersion === 'live' ? 'Live' : 'Staging'} Version
        </Button>
        </div>
      </div>

      <div className={classes.previewContainer}>
        <div className={classes.previewWrapper}>
          <SalesPage 
            isPreview={true} 
            customContent={currentContent}
            customStyles={currentStyles}
          />
        </div>
      </div>
    </div>
  );
} 